module.exports = __webpack_public_path__ + "mq.svg?ce45144d9a07d169c093e48e9b58d05c";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/mq.svg
// module id = 1325
// module chunks = 27